import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminHeader, RoleProtectedRoute } from '../../../shared/components';
import { useRoles } from '../../../shared/hooks';
import AuditLogsList from './AuditLogsList';

/**
 * Pantalla de auditoría de movimientos de entradas.
 * Solo para administradores: el endpoint usa AdminRoleGuard.
 */
const AuditLogsManagement = ({ adminData, onLogout }) => {
  const navigate = useNavigate();
  const { ROLES } = useRoles();

  const handleBackToDashboard = () => {
    navigate('/admin');
  };

  return (
    <RoleProtectedRoute requiredRoles={[ROLES.ADMIN]}>
      <div className="min-h-screen bg-gray-50">
        <AdminHeader
          adminData={adminData}
          onLogout={onLogout}
          showBackButton={true}
          onBackClick={handleBackToDashboard}
          backButtonText="Volver al Dashboard"
        />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <AuditLogsList />
        </main>
      </div>
    </RoleProtectedRoute>
  );
};

export default AuditLogsManagement;
